import { render, staticRenderFns } from "./TopText.vue?vue&type=template&id=73e2181f"
import script from "./TopText.vue?vue&type=script&lang=ts"
export * from "./TopText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports